<template>
  <FlexBox
    grow
    direction="row"
    alignment="right"
  >
    <label
      v-tooltip="{ text: translate('pb2.presetTagViewMode.compact') }"
      class="pb-half-margin-right"
    >
      <UiIcon icon="logs" />
      <input
        v-model="tagViewMode"
        type="radio"
        :value="false"
        :aria-label="translate('pb2.presetTagViewMode.compact')"
      >
    </label>
    <label
      v-tooltip="{ text: translate('pb2.presetTagViewMode.extended') }"
    >
      <UiIcon icon="menu" />
      <input
        v-model="tagViewMode"
        type="radio"
        :value="true"
        :aria-label="translate('pb2.presetTagViewMode.extended')"
      >
    </label>
  </FlexBox>
</template>

<script setup>
import { computed, toRef } from 'vue'
import FlexBox from '@nicolaudie-group/ng-ui-kit/components/FlexBox/FlexBox.vue'
import UiIcon from '@nicolaudie-group/ng-ui-kit/components/UiIcon/UiIcon.vue'
import vTooltip from '@nicolaudie-group/ng-ui-kit/directives/vTooltip'
import useProfileStore from '@/stores/profile.store'
import translate from '@/helpers/translate'

const profileStore = useProfileStore()

const tag = toRef(profileStore, 'tag')
const tagPreferences = toRef(profileStore, 'tagPreferences')

const tagViewMode = computed({
  get() {
    return tag.value.preferences.extended
  },
  set(value) {
    tagPreferences.value[tag.value.path] = {
      ...tag.value.preferences,
      extended: value,
    }
  },
})
</script>
